import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuccessToasterState } from '@/modules/SuccessToaster/store/state';

export const getters: GetterTree<SuccessToasterState , RootState> = {
    isActive(state) {
        return state.activeToast;
    },
};
